import type { TooltipFormatterContextObject } from "highcharts";
import type { IntlShape } from "react-intl";

export default function getXOrLastGroupNode(context: TooltipFormatterContextObject, intl: IntlShape) {
  if (context.point.dataGroup) {
    return intl.formatDate(
      (context.point.series as any).xData[context.point.dataGroup.start + context.point.dataGroup.length - 1],
      {
        year: "numeric",
        month: "numeric",
        day: "numeric",
      },
    );
  }

  if (context.x && typeof context.x !== "string") {
    return intl.formatDate(context.x, {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    });
  }

  return context.x;
}
